export const getVirtualWindow = (
  count: number,
  rowHeight: number,
  scrollTop: number,
  viewportHeight: number,
  overscan = 5
) => {
  if (count <= 0) {
    return { start: 0, end: 0, totalHeight: 0 };
  }
  const start = Math.max(0, Math.floor(scrollTop / rowHeight) - overscan);
  const visible = Math.max(1, Math.ceil(viewportHeight / rowHeight));
  const end = Math.min(count, start + visible + overscan * 2);
  return { start, end, totalHeight: count * rowHeight };
};
